import { Injectable } from "@angular/core";
import { Preferences } from "@capacitor/preferences";
import Cookies from 'js-cookie';

export type stateSkin = "PA" | "NJ" | "";

@Injectable({
  providedIn: "root",
})
export class AppstorageTsService {

  private _splashPageState: stateSkin;

  constructor() { }

  async setJurisdiction(state: stateSkin) {
    return await Preferences.set({
      key: "jurisdiction",
      value: state,
    });
  }

  async getJurisdiction() {
    return await Preferences.get({ key: "jurisdiction" });
  }

  async setSplashPageState(state: stateSkin) {
    return this._splashPageState = state;
  }

  getSplashPageState(): stateSkin {
    return this._splashPageState;
  }

  //web storage methods to check/store jurisdiction value in localStorage
  async setWebSplashSelection(value) {
    //return await localStorage.setItem('jurisdiction', value);
    return await Cookies.set('jurisdiction', value, { domain: this.getMainDomainName() });
  }

  async getWebSplashSelection() {
    return await Cookies.get('jurisdiction', { domain: this.getMainDomainName() });
  }

  async setSkipAskCustomerRotate(isSkip: boolean) {
    return await Preferences.set({
      key: "skip_ask_customer_rotate",
      value: isSkip ? "true" : "false",
    });
  }

  async getSkipAskCustomerRotate() {
    return await Preferences.get({ key: "skip_ask_customer_rotate" });
  }


  getMainDomainName() {
    if (window.location.hostname == 'localhost') {
      return 'localhost'
    } else {
      return window.location.hostname.split('.').slice(-2).join('.')
    }
  }
}
